


















import { Component, Vue, Mixins } from 'vue-property-decorator';
import FooterMenu from '@/components/FooterMenu.vue';
import UserMixin from '@/mixins/UserMixin';
import { SignInArguments } from '@/common/apis/AccountApi';

@Component({
    components: {
        FooterMenu,
    },
})
export default class Welcome extends Mixins(UserMixin) {

    public loading: boolean = false;

    public created(): void {
        this.verifyLoginStatus(false);
    }

    public demo(): void {
        this.$store.dispatch('user/login', new SignInArguments({
            email: 'demo',
            password: '',
        }))
        .then(() => {
            this.loading = false;
            this.$router.push('/devices');
        })
        .catch((e) => {
            this.loading = false;
            alert(e);
        });
        this.loading = true;
    }
}

